/* eslint-disable */
// @ts-nocheck

import { ChevronDoubleRight } from 'heroicons-react'
import { createContext, useContext, useEffect, useState } from 'react'
import {
  useFieldArray,
  UseFieldArrayAppend,
  UseFieldArrayRemove,
  UseFieldArrayUpdate,
  useForm,
} from 'react-hook-form'

import Button from '../../../../../components/misc/Button'
import EmptyList from '../../../../../components/misc/EmptyList'
import SearchComponent from '../../../../../components/misc/SearchComponent'
import SpinnerLoading from '../../../../../components/misc/SpinnerLoading'
import { StockAreaProducts } from '../../../../../interfaces/ServerInterfaces'
import { DispatchContext } from './DispatchWizard'
import ReceivedList from './ReceivedList'
import SendList from './SendList'

interface ProductMovement {
  stockProducts: StockAreaProducts[]
  loading: boolean
}

export interface VisualData {
  id: number
  productId: number
  quantity?: number
  available: number
  name: string
  measure: string
  variations: {
    id: number
    name: string
    available: number
    quantity?: number
  }[]
}

export interface FieldProductData {
  productId: number
  productName: string
  quantity?: number
  measure: string
  available: number
  variationId?: number
  variationName?: string
}

interface ProductDispatchInterface {
  fields: Record<'id' | string, any>[]
  append: UseFieldArrayAppend<Record<string, any>, 'products'>
  update: UseFieldArrayUpdate<Record<string, any>, 'products'>
  remove: UseFieldArrayRemove
  products: VisualData[]
}

export const DispatchProductContext = createContext<
  Partial<ProductDispatchInterface>
>({})

const ProductMovementStep = ({ stockProducts, loading }: ProductMovement) => {
  const {
    setCurrentStep,
    watch,
    transformingToDispatch,
    despacho,
    setValue,
    fields,
    append,
    update,
    remove,
  } = useContext(DispatchContext)

  //Data for Product List to Select ----------------------------------------------------------------
  const [filter, setFilter] = useState<string | null>(null)
  const products: VisualData[] = stockProducts
    .filter(
      (elem) =>
        !!elem.product.name
          .toLocaleLowerCase()
          .includes((filter ?? '').toLocaleLowerCase())
    )
    .map((item) => ({
      id: item.id,
      productId: item.product.id,
      name: item.product.name,
      measure: item.product.measure,
      available: item.quantity,
      variations: item?.variations?.map((itm) => ({
        id: itm.variationId,
        name: itm.variation.name,
        available: itm.quantity,
      })),
    }))
  //----------------------------------------------------------------------------------------------

  const originArea = watch!('originAreaName')
  const destinationArea = watch!('destinationAreaName')

  useEffect(() => {
    if (transformingToDispatch && stockProducts.length > 0) {
      const stockProductsTransformingDispatch = stockProducts.map((prod) => {
        const quantity =
          despacho?.products.find((item) => item.productId === prod.product.id)
            ?.quantity ?? 0

        const available = prod.product.totalQuantity
        const availableRest = available - quantity

        const productFinded = despacho?.products.find(
          (elem) => elem.productId === prod.product.id
        )

        if (productFinded) {
          return {
            productId: prod.product.id,
            productName: prod.product.name,
            measure: prod.product.measure,
            quantity: quantity,
            available: availableRest,
            id: prod.id,
          }
        }
      })

      setValue!(
        'products',
        stockProductsTransformingDispatch.filter((item) => item !== undefined),
        {
          shouldValidate: true, // Opcional: valida los campos después de configurarlos
        }
      )
    }
  }, [transformingToDispatch, stockProducts, despacho, setValue])

  if (loading)
    return (
      <div className="h-96">
        <SpinnerLoading />
      </div>
    )
  return (
    <DispatchProductContext.Provider
      value={{ append, fields, remove, update, products }}
    >
      <div className="grid grid-cols-11 gap-2">
        <div className="col-span-11 w-full rounded p-2 shadow-sm">
          <SearchComponent
            findAction={(find: string | null) => setFilter(find)}
            placeholder="Buscar Producto"
          />
        </div>
        <div className="relative col-span-5 h-96 justify-center overflow-y-auto rounded-md border border-slate-300 p-3 scrollbar-thin">
          <span>{}</span>
          <SendList />
        </div>
        <div className="col-span-1 flex flex-col items-center justify-center gap-3">
          <div className="rounded-md border border-slate-100 bg-slate-50 px-2 py-1 text-center text-xs shadow-sm">
            <p className="font-semibold underline">Desde:</p> {originArea}
          </div>
          <div className="flex h-14 w-14 justify-center border">
            <ChevronDoubleRight
              className="h-14 text-slate-500"
              onPointerEnterCapture={undefined}
              onPointerLeaveCapture={undefined}
            />
          </div>
          <div className="rounded-md border border-slate-100 bg-slate-50 px-2 py-1 text-center text-xs shadow-sm">
            <p className="font-semibold underline">Hacia:</p> {destinationArea}
          </div>
        </div>
        <div className="col-span-5 h-96 overflow-y-auto rounded-md border border-slate-300 p-3 scrollbar-thin">
          {(
            transformingToDispatch
              ? !transformingToDispatch
              : fields?.length === 0
          ) ? (
            <div className="flex h-full items-center justify-center">
              <EmptyList />
            </div>
          ) : (
            <ReceivedList />
          )}
        </div>
      </div>

      {/* Total de unidades seleccionadas - discreto */}
      {fields && fields.length > 0 && (
        <div className="my-2 flex items-center justify-end gap-2">
          <span className="text-sm text-slate-600">
            Total de unidades seleccionadas:
          </span>
          <span className="rounded bg-slate-600 px-2 py-1 text-sm font-semibold text-white">
            {(fields ?? []).reduce((acc, prod) => acc + (Number(prod?.quantity) || 0), 0)}
          </span>
        </div>
      )}

      <div className="grid grid-cols-2 gap-2 py-2">
        <Button
          action={() => setCurrentStep!(0)}
          color="gray-900"
          full
          name="Atrás"
          outline
          textColor="slate-800"
        />
        <Button
          action={() => setCurrentStep!(2)}
          color="slate-600"
          disabled={fields?.length === 0}
          name="Siguiente"
        />
      </div>
    </DispatchProductContext.Provider>
  )
}

export default ProductMovementStep
